module.exports = __webpack_public_path__ + "img/ic_head_hight_4.12f75733.png";